import { render, staticRenderFns } from "./ViewAsignedRole.vue?vue&type=template&id=0b85b876&"
import script from "./ViewAsignedRole.vue?vue&type=script&lang=js&"
export * from "./ViewAsignedRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports